import { createFileRoute } from "@tanstack/react-router"
import { ButtonLink } from "@fieldbook/ui/button-link"
import { CachedImage } from "@/components/common/CachedImage"

// Served from public/ so the PWA asset generator writes its icon set alongside it.
const fieldbookLogo = "/logo-no-bg.png"

export const HomePage = () => {
  return (
    <div className="flex h-screen flex-col justify-center bg-fixed">
      <div className="flex w-full flex-col items-center justify-center gap-4 text-center md:mx-auto md:w-2/3 md:rounded-xl lg:w-1/2">
        <CachedImage
          src={fieldbookLogo}
          alt="fieldbook logo"
          className="w-full sm:w-1/2 md:w-1/2"
        />
        <p className="text-secondary-foreground p-6">
          Welcome to Fieldbook, your ecological fieldwork companion
        </p>
        <ButtonLink
          size={"lg"}
          to="/projects"
          className="bg-primary mt-10 p-6 text-2xl shadow shadow-purple-400"
        >
          Log in
        </ButtonLink>
      </div>
    </div>
  )
}

export const Route = createFileRoute("/")({
  component: HomePage,
})
